var map = {
	"./Average_1.png": "6035",
	"./Happy_1.png": "98d0",
	"./Sad_1.png": "f19c",
	"./VeryHappy_1.png": "7ea6",
	"./VerySad_1.png": "c2eb",
	"./calculator.svg": "90c4",
	"./data-visualization.png": "77bc",
	"./feedback.jpg": "71ca",
	"./feedback1080.jpg": "fbf4",
	"./global.css": "150b",
	"./hommer_logo_red.svg": "7594",
	"./logo.png": "cf05",
	"./neutral.png": "5fe8",
	"./qu-code.jpg": "5543",
	"./sad.png": "b92b",
	"./smile.png": "84b1",
	"./tailwind.css": "ba8c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";